import apiClient from './axios';

export async function fetchAdminPermissions(userUuid) {
  const res = await apiClient.get('/v3/admin-permission', {
    params: { userUuid },
  });

  return res.data;
}

export async function saveAdminPermissions(userUuid, permissions) {
  const res = await apiClient.patch('/v3/admin-permission', {
    userUuid,
    permissions,
  });

  return res.data;
}

export async function createDefaultAdminPermissions(userUuid) {
  const res = await apiClient.post('/v3/admin-permission/default', {
    userUuid,
  });

  return res.data;
}
